import { useMutation, useQueryClient } from "@tanstack/react-query"
import { students } from  '@shared/api/services'

export const useDisconnectStudent = (onSuccess = () => {}) => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: students.disconnectStudentById,
    onSuccess: () => {
      queryClient.invalidateQueries(['my-students'])
			onSuccess()
    },
  })

	return mutation
}